import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import HolographicBg from "@/components/HolographicBg";
import TopBar from "@/components/TopBar";
import ChangePasswordCard from "@/components/ChangePasswordCard";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function InfluencerDashboard() {
  const { user, loading } = useAuth();
  const [events, setEvents] = useState([]);
  const [tickets, setTickets] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/influencer/login"); return; }
    if (user.role !== "influencer" && user.role !== "admin") { navigate("/"); return; }
    api.get("/events").then(({ data }) => setEvents(data));
    api.get("/dashboard/me").then(({ data }) => setTickets(data.tickets));
  }, [user, loading, navigate]);

  if (!user) return null;

  return (
    <div className="relative min-h-screen">
      <HolographicBg />
      <TopBar />
      <main className="relative z-20 px-6 py-10 max-w-6xl mx-auto" data-testid="influencer-dashboard">
        <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-fuchsia-400">— VIP tier —</div>
        <h1 className="font-display text-4xl font-black uppercase mt-2 neon-magenta">Welcome, {user.full_name}</h1>
        <p className="font-mono text-xs uppercase tracking-widest text-white/60 mt-3">
          {user.influencer_tier === "discount" ? "25% off entry" : "Comp entry"} · 24–48hr early access · Identity Vault unlocked
        </p>

        <div className="flex gap-3 mt-8">
          <Link to="/vault" data-testid="influencer-vault-cta" className="gate inline-block px-6 py-3 bg-fuchsia-500 text-black font-display font-bold uppercase tracking-[0.3em] text-xs rounded-sm">Open Identity Vault</Link>
        </div>

        <section className="mt-12">
          <h2 className="font-display text-2xl font-bold uppercase">Early access events</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
            {events.map((e) => (
              <Link key={e.id} to={`/event/${e.id}`} className="glass rounded-sm p-5 hover:border-fuchsia-400/40 transition">
                <div className="font-display text-lg font-bold uppercase">{e.name}</div>
                <div className="font-mono text-xs uppercase tracking-widest text-white/50 mt-1">{e.date}</div>
                <div className="font-mono text-xs uppercase tracking-widest text-fuchsia-400 mt-3">{user.influencer_tier === "discount" ? "25% off entry" : "Comp entry"}</div>
              </Link>
            ))}
          </div>
        </section>

        <section className="mt-12">
          <h2 className="font-display text-2xl font-bold uppercase">Your appearances</h2>
          <div className="space-y-3 mt-4">
            {tickets.length === 0 && <div className="font-mono text-sm text-white/50">No appearances yet.</div>}
            {tickets.map((t) => (
              <div key={t.id} className="glass rounded-sm p-4">
                <div className="font-display font-bold uppercase">{t.event?.name}</div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-white/40">{t.event?.date} · {t.type}</div>
              </div>
            ))}
          </div>
        </section>
        <ChangePasswordCard accent="magenta" showTempKeyBanner={!!user.temp_key_issued_at} />
      </main>
    </div>
  );
}
